import * as Mui from "@mui/material";
import * as MuiIcons from "@mui/icons-material";
import { useState } from "react";
import FileUploader from "../../../../../util/component/FileUploader";
import useOperationTranslation from "../../../hooks/useOperationTranslation";

interface Props {
    open: boolean;
    onClose: () => void;
    onUploadFile: (file: File) => void;
};

const AggiungiAllegato = (props: Props) => {

const [fileUploaded, setFileUploaded] = useState<File>();

const onFileUpload = (file: File) => {
    setFileUploaded(file);
}

const onConfirm = () => {
    if (fileUploaded){
        props.onUploadFile(fileUploaded);
    }

    props.onClose();
}

const t = useOperationTranslation();
    return(
        <Mui.Dialog
            open={props.open}
            onClose={props.onClose}
            fullWidth
            maxWidth="sm"
        >
            <Mui.DialogTitle>
                <Mui.Grid container spacing={1} alignItems={"center"}>
                    <Mui.Grid item sx={{color: "rgb(209, 44, 147)"}}>
                        {<MuiIcons.Info/>}
                    </Mui.Grid>
                    <Mui.Grid item>
                        <Mui.Typography variant="h5">
                        {t("vehicleEntrance.vehicleEntranceFirstFueling.aggiungiAllegato.headerTitle")}
                        </Mui.Typography>
                    </Mui.Grid>
                    <Mui.Grid item  marginLeft={"auto"}>
                        <Mui.IconButton onClick={props.onClose}>
                            <MuiIcons.Close />
                        </Mui.IconButton>
                    </Mui.Grid>
                </Mui.Grid>
            </Mui.DialogTitle>

            <Mui.DialogContent>

                <FileUploader
                    onUpload={onFileUpload}
                    acceptedFiles={{'application/pdf': ['.pdf'],'image/png': ['.png'],'image/jpg': ['.jpg'],'image/jpeg':['.jpeg'], 'image/tif': ['.tif'],'image/tiff': ['.tiff'],'image/bmp': ['.bmp'],}}
                />

            </Mui.DialogContent>
           
            <Mui.DialogActions>
                <Mui.Grid container spacing={1}>
                    <Mui.Grid item xs={12} md={6}>
                        <Mui.Button type="submit" size="smallPlus" fullWidth onClick={onConfirm}>
                            <Mui.Typography variant="h6" color="inherit">
                            {t("vehicleEntrance.vehicleEntranceFirstFueling.aggiungiAllegato.buttonConferma")}
                            </Mui.Typography>
                        </Mui.Button>
                    </Mui.Grid>
                    <Mui.Grid item xs={12} md={6}>
                        <Mui.Button variant="outlined" size="smallPlus" onClick={props.onClose} fullWidth>
                            <Mui.Typography variant="h6" color="inherit">
                            {t("vehicleEntrance.vehicleEntranceFirstFueling.aggiungiAllegato.buttonAnulla")}
                            </Mui.Typography>
                        </Mui.Button>
                    </Mui.Grid>
                </Mui.Grid>
            </Mui.DialogActions>
        </Mui.Dialog>
    )
}
export default AggiungiAllegato;